import { fromJS } from 'immutable'
import { RxConversationAPI } from '@driftt/dapper'


export const fetchReplies = () => {
  return RxConversationAPI.get('/snippets')
    .checkStatus()
    .retryWithBackoff()
    .mapResponse(fromJS)
}

export const fetchReply = (replyId) => {
  return RxConversationAPI.get(`/snippets/${replyId}`)
    .checkStatus()
    .retryWithBackoff()
    .mapResponse(fromJS)
}

export const createReply = (reply) => {
  return RxConversationAPI.post('/snippets', reply)
  .checkStatus()
  .retryWithBackoff()
}

export const updateReply = (replyId, reply) => {
  return RxConversationAPI.patch(`/snippets/${replyId}`, reply)
  .checkStatus()
  .retryWithBackoff()
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/composer/api.js